<template>
	<div class="plane-problem-answer">
		<van-nav-bar
			:class="{'isiOSX':isiOSX}"
		  title="常见问题"
		  left-arrow
		  @click-left="reBack"
		/>
	  	<van-row class="answer">
		  	<van-col class="title" span="24">
		  		<img src="../../assets/plane/ask@2x.png" />{{info.issue}}
		  	</van-col>
		  	<van-col span="24" class="answer-con">
		  		{{info.answer}}
		  	</van-col>
		</van-row>
	</div>
</template>

<script>
export default {
	data() {
	    return {
	      info: '',
	      isiOSX: false
	     
	    };
	},
	created(){
	　　	 this.getInfo()
  		this.isiOSX = this.isIphoneX();
	},
	methods: {
	   	getInfo() {
	      this.$api.post("/setting/index/common/problems/detail",{id:this.$route.query.id}).then(res => {
	        this.info = res;
	      });
	    },
	    reBack() {
	    	this.$router.go(-1);
	    }
	}
};
</script>

<style lang="less">
.plane-problem-answer {
	height: 100%;
	background: #f2f2f2;
	.van-nav-bar {
  		background: #F2F2F2;
  		padding-top: 24px;
  		position: relative;
  		.van-nav-bar__title {
  			font-size: 18px;
  			color: #333;
  		}
  		.van-nav-bar__text {
  			color: #333;
  			font-size: 14px;
  		}
  		.van-icon-arrow-left:before {
  			display: none;
  		}
  		.van-nav-bar__left {
  			left: 11px;
  			.van-icon {
  				width: 17px;
  				height: 15px;
  				display: inline-block;
  				background: url(../../assets/plane/reBack.png) no-repeat center center;
  				background-size: 100% 100%;
  			}
  		}
  	}
  	.isiOSX {
  		padding-top: 44px;
  	}
	.answer {
		background: #fff;
		margin-bottom: 7px;
		padding: 0 11px 10px;
		box-shadow: #E3E3E3 2px 0 4px;
		.title {
			color: #333;
			font-size: 14px;
			font-weight: bold;
			height: 53px;
			line-height: 53px;
			margin-bottom: 10px;
			border-bottom: solid 1px #F2F2F2;
			img {
				width: 22px;
				margin-right: 9px;
				float: left;
				margin-top: 15px;
			}
		}
		.answer-con {
			text-align: left;
			font-size: 13px;
		}
	}
}

</style>
